import React from "react";
import SFIcon from "@/custom_components/SFIcon/SFIcon";
import { helpIconFor } from "./helpIcons";
import classes from "./Help.module.css";

/**
 * One FAQ accordion row.
 *
 * FAQs render as a flat list in sortOrder, not grouped by iconId, so the icon
 * rides on the card itself — together with `title` it's the only thing left
 * carrying the record's category.
 *
 * `title` is that category ("Refunds"), never the question.
 */
const FaqItem = ({ faq, open, onToggle }) => {
  const buttonId = `faq-btn-${faq._id}`;
  const panelId = `faq-panel-${faq._id}`;

  return (
    <div className={`${classes.faqItem} ${open ? classes.faqItemOpen : ""}`}>
      <button
        type="button"
        id={buttonId}
        className={classes.faqQuestion}
        aria-expanded={open}
        aria-controls={panelId}
        onClick={onToggle}
      >
        <span className={classes.iconChip}>
          <SFIcon name={helpIconFor(faq.iconId)} size={15} />
        </span>
        <span className={classes.faqQuestionText}>
          {faq.title ? <span className={classes.faqEyebrow}>{faq.title}</span> : null}
          <span className={classes.faqQuestionLine}>{faq.question}</span>
        </span>
        <SFIcon
          name="expand"
          size={13}
          className={`${classes.faqChevron} ${open ? classes.faqChevronOpen : ""}`}
        />
      </button>

      {open && (
        <div id={panelId} role="region" aria-labelledby={buttonId} className={classes.faqAnswer}>
          {/* Plain text from the API — never HTML. Rendered as a text node so
              pre-wrap preserves whatever line breaks the admin typed. */}
          {faq.answer}
        </div>
      )}
    </div>
  );
};

export default FaqItem;
